module.exports = __webpack_public_path__ + "img/gBalm6.08541c5d.jpg";